/**
 * LinkLane brand primitives.
 * BrandMark — circular badge with the LinkLane tree icon.
 * Wordmark  — "Link" in ink + "Lane" in candy purple italic, Fraunces serif
 *             (matches the headings + footer giant wordmark).
 */

const SIZES = {
  xs: { box: 28, pad: 4, text: "text-base" },
  sm: { box: 34, pad: 5, text: "text-lg" },
  md: { box: 40, pad: 6, text: "text-xl md:text-2xl" },
  lg: { box: 56, pad: 9, text: "text-3xl md:text-4xl" },
  xl: { box: 72, pad: 12, text: "text-5xl md:text-6xl" },
};

const TONES = {
  candy: "bg-candy text-white",
  ink: "bg-ink text-white",
  yellow: "bg-yellow text-ink",
  mint: "bg-mint text-ink",
  pink: "bg-pink text-ink",
  paper: "bg-white text-ink",
};

export const BrandMark = ({
  size = "md",
  tone = "ink",
  rotate = -6,
  className = "",
  animate = true,
  ...rest
}) => {
  const s = SIZES[size];
  // The new mark SVG is self-contained (white tile + navy L + violet stroke +
  // its own sticker shadow), so no wrapper tile/border here. `tone` kept for
  // backward-compat with call sites but no longer drives a background.
  void tone;
  return (
    <span
      aria-hidden
      style={{
        width: s.box,
        height: s.box,
        transform: `rotate(${rotate}deg)`,
      }}
      className={`inline-flex shrink-0 items-center justify-center ${
        animate
          ? "transition-transform duration-300 ease-bouncy group-hover:rotate-0 group-hover:scale-105"
          : ""
      } ${className}`}
      {...rest}
    >
      <img
        src="/brand/linklane-mark.svg"
        alt=""
        style={{ width: "100%", height: "100%", objectFit: "contain" }}
        draggable={false}
      />
    </span>
  );
};

export const Wordmark = ({
  size = "md",
  tone = "ink", // brand mark tone
  className = "",
  withMark = true,
  accent = "candy",
  ...rest
}) => {
  const s = SIZES[size];
  const accentCls =
    accent === "pink"
      ? "text-pink"
      : accent === "yellow"
        ? "text-yellow"
        : accent === "mint"
          ? "text-mint"
          : "text-candy";

  return (
    <span className={`group inline-flex items-center gap-1.5 md:gap-2 ${className}`} {...rest}>
      {withMark ? <BrandMark size={size} tone={tone} /> : null}
      <span className={`font-serif font-semibold leading-none tracking-tight ${s.text}`}>
        <span>Link</span>
        <span className={`${accentCls} italic`}>Lane</span>
      </span>
    </span>
  );
};

export default Wordmark;
